export default __webpack_public_path__ + "static/media/mode-22.b951c389.svg";